import { logger, bigQuery, mixpanel } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';

const categoryViewedMP = ({ category }) => {
    if (!category || !category.name) {
        return logger.error(`Mixpanel categoryViewed event sending failure - category.name is ${category.name}`);
    }

    const payload = {
        'Page Name': 'Fiverr Guides: Category',
        'Category Name': category.name,
    };

    mixpanel.trackPageView(payload);
};

const homeViewedMP = () => {
    mixpanel.trackPageView({
        'Page Name': 'Fiverr Guides: Home',
    });
};

const guideViewedMP = ({ guide, category }) => {
    if (!guide || !guide.name) {
        return logger.error(`Mixpanel guideViewed event sending failure - guide.name is ${guide.name}`);
    }

    if (!category || !category.name) {
        return logger.error(`Mixpanel categoryViewed event sending failure - category.name is ${category.name}`);
    }

    const payload = {
        'Page Name': 'Fiverr Guides: Guide article',
        'Guide Name': guide.name,
        'Category Name': category.name,
    };

    mixpanel.trackPageView(payload);
};

const eventTypeToPageNameMap = {
    HP: 'Fiverr Guides - Homepage',
    Category: 'Fiverr Guides - Category',
    Article: 'Fiverr Guides - Guide Article',
};

// type: HP/Category/Article/Tag
const pageViewBQ = ({ type, data = {} }) => {
    if (typeof bigQuery === 'undefined') {
        return logger.error('bigQuery is missing in window');
    }

    const { userId, userGuid, pageCtxId } = getContext();

    const event = {
        type,
        group: 'fiverr_guides',
        platform: 'web',
        user: { id: userId },
        uid: userGuid,
        page: { name: eventTypeToPageNameMap[type], ctx_id: pageCtxId },
        domain: { name: 'fiverr_guides' },
        ...data,
    };

    bigQuery.send(event);
};

export const categoryViewed = (data) => {
    categoryViewedMP(data);
    pageViewBQ({ type: 'Category', data });
};

export const homeViewed = () => {
    homeViewedMP();
    pageViewBQ({ type: 'HP' });
};

export const guideViewed = (data) => {
    guideViewedMP(data);
    pageViewBQ({ type: 'Article', data });
};

export const carouselQueryParams = () => ({
    context_referrer: 'fiverr_guides_guide',
    source_type: 'carousel',
    // guide: article_id,
});

export const linkQueryParams = () => ({
    context_referrer: 'fiverr_guides_guide',
    source_type: 'link',
    // guide: article_id,
});

export const carouselQueryParamEnrichments = () => ({
    queryParameters: carouselQueryParams(),
    gigQueryParams: carouselQueryParams(),
    sellerQueryParams: carouselQueryParams(),
});
